exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".filter-component {\n  padding: 10px;\n  margin: 12px;\n  background-color: #f1f1f1;\n  box-shadow: 0 0px 6px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  box-sizing: border-box;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/component/filter/index.css
// module id = 778
// module chunks = 0